// Nauma sticky mobile Add-to-Cart bar.
// Toggles visibility once the real Add to Cart button scrolls out of view,
// and mirrors its price/disabled/loading state so the two never disagree.
// Visibility on desktop vs. mobile is controlled entirely by CSS
// (nauma-sticky-atc.css) — this script only ever toggles a class.
(function () {
  function syncFromMain(root, sectionId) {
    var mainPrice = document.getElementById('price-' + sectionId);
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var stickyPrice = document.getElementById('NaumaStickyAtcPrice-' + sectionId);
    var stickyButton = document.getElementById('NaumaStickyAtcButton-' + sectionId);
    var stickyButtonText = document.getElementById('NaumaStickyAtcButtonText-' + sectionId);

    if (mainPrice && stickyPrice) stickyPrice.innerHTML = mainPrice.innerHTML;

    if (mainButton && stickyButton) {
      var disabled = mainButton.hasAttribute('disabled') || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.toggleAttribute('disabled', disabled);
      stickyButton.classList.toggle('loading', mainButton.classList.contains('loading'));

      var mainText = mainButton.querySelector('span');
      if (stickyButtonText && mainText && mainText.textContent.trim()) {
        stickyButtonText.textContent = mainText.textContent.trim();
      }
    }
  }

  function initStickyAtc(root) {
    var sectionId = root.dataset.sectionId;
    var watchTarget = document.getElementById(root.dataset.watchTarget);

    if (watchTarget && 'IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            root.classList.toggle('nauma-sticky-atc--visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      visibilityObserver.observe(watchTarget);
    }

    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (mainButton && 'MutationObserver' in window) {
      var stateObserver = new MutationObserver(function () {
        syncFromMain(root, sectionId);
      });
      stateObserver.observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.sectionId === sectionId) {
          syncFromMain(root, sectionId);
        }
      });
    }
  }

  document.querySelectorAll('[data-nauma-sticky-atc]').forEach(initStickyAtc);
})();
